import { ThemeOptions } from '@mui/material';

export const MuiCard: ThemeOptions['components']['MuiCard'] = {
  defaultProps: {
    variant: 'outlined'
  },
  styleOverrides: {
    root: ({ theme }) => ({
      border: `1px solid ${theme.palette.divider}`
    })
  }
};

export const MuiCardContent: ThemeOptions['components']['MuiCardContent'] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        padding: theme.spacing(0, 2),
        // If it is the first or last child of the card, we want to add padding
        '&:first-child': {
          paddingTop: theme.spacing(2)
        },
        '&:last-child': {
          paddingBottom: theme.spacing(2)
        }
      };
    }
  }
};

export const MuiCardActions: ThemeOptions['components']['MuiCardActions'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      // Default padding is 8px, but we want to match the card content padding
      padding: theme.spacing(2)
    })
  }
};

export const MuiCardActionArea: ThemeOptions['components']['MuiCardActionArea'] = {
  defaultProps: {
    disableRipple: true
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '&:hover .MuiCard-root': {
        backgroundColor: theme.palette.action.hover,
        boxShadow: theme.shadows[2]
      },
      '&:hover>.MuiCardActionArea-focusHighlight': {
        opacity: 0
      }
    })
  }
};

export const MuiCardHeader: ThemeOptions['components']['MuiCardHeader'] = {
  styleOverrides: {
    action: {
      // Default behavior is marginRight: -8px which made borderless buttons like
      // iconButton look aligned, but made other buttons look misaligned.
      marginRight: 0
    }
  }
};
